import { cn } from '@/shared/lib/utils';
import { ICONS, type IconName } from './icons';

interface IconProps {
  name: IconName;
  /** 표시 크기(px). SVG 원본 크기와 다르면 비율대로 축소·확대된다 */
  size: 4 | 14 | 16 | 24;
  className?: string;
}

/** 장식용 아이콘 — 의미가 있으면 감싼 버튼에 aria-label을 준다 */
export function Icon({ name, size, className }: IconProps) {
  return (
    <img
      src={ICONS[name]}
      alt=""
      aria-hidden
      width={size}
      height={size}
      className={cn('block shrink-0', className)}
      style={{ width: size, height: size }}
    />
  );
}
